import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventInfo } from './useEventInfo';
import { useIsNewStackEvent } from './useIsNewStackEvent';
import { resolveGuestListRoute } from './guestListRoute';
import type { GuestListRoute } from './guestListRoute.types';

/**
 * Deliberately NOT re-exported from `@shared/utils/eventInfo`, for the same reason as
 * `useIsNewStackEvent`, which this hook calls directly from its own module rather than the barrel.
 */
export const useGuestListRoute = (): GuestListRoute => {
  const { eventInfo } = useEventInfo();
  const isNewStackEvent = useIsNewStackEvent();
  const [useDirectGuestListV2] = useIsFeatureEnabled('useDirectGuestListV2');

  return useMemo(
    () =>
      resolveGuestListRoute({
        eventType: eventInfo?.eventType,
        isNewStackEvent,
        useDirectGuestListV2,
      }),
    [eventInfo?.eventType, isNewStackEvent, useDirectGuestListV2],
  );
};
